<template>
  <div class="pa-2">
    <section class="cargo-hierarchy-card">
      <draggable
        ref="drag"
        v-model="alocatedStops"
        v-bind="dragOptions"
        multi-drag
        tag="div"
        selected-class="multi-drag"
        @add="onAdd"
      >
        <div class="pa-4">
          <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
            <div class="d-flex">
              <div class="d-flex pr-1">
                <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold"> Carga: </span>
                <span class="font-weight-regular"> {{ cargo.cargoNumber }} </span>
              </div>
              <div v-if="cargo.isDirectDelivery" class="mr-4">
                <span class="font-weight-bold">Entrega Direta</span>
              </div>
              <div v-else class="mr-4">
                <span class="font-weight-bold">Transbordo: </span>
                <TruncateDataWithTooltip
                  :data="cargo.transhipmentName"
                  :lengthDataToTruncate="truncateLimit"
                ></TruncateDataWithTooltip>
              </div>
              <div v-if="!cargo.isDirectDelivery" class="mr-4">
                <span class="font-weight-bold">Cidade: </span>
                <span class="font-weight-">{{ cargo.transhipmentCity }}</span>
              </div>
            </div>
            <div class="d-flex">
              <v-icon v-if="isCollapsed" @click="isCollapsed = !isCollapsed">mdi-chevron-down</v-icon>
              <v-icon v-else @click="getStopsByCargo(true)">mdi-chevron-right</v-icon>
              <v-icon class="ml-2" @click="openDeleteDialog(cargo.id)"> mdi-close </v-icon>
            </div>
          </v-card-text>

          <v-card-text class="d-flex pa-0">
            <v-col class="pa-0" cols="12" md="12">
              <span v-if="!cargo.isDirectDelivery" class="font-weight-bold text--secondary">Frete do transbordo: </span>
              <span v-if="!cargo.isDirectDelivery" class="font-weight-regular mr-4">{{
                formatPrice(cargo.totalTranshipmentPrice)
              }}</span>
              <span class="font-weight-bold text--secondary">Frete embarcador: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(cargo.totalPriceDeliveries) }}</span>
              <span class="font-weight-bold text--secondary">Valor das mercadorias: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(cargo.totalPriceNfes) }}</span>
              <span class="font-weight-bold text--secondary">Peso: </span>
              <span class="font-weight-regular mr-4">{{ formatWeight(cargo.weightDeliveries || 0) }}kg</span>
              <span class="font-weight-bold text--secondary">Quantidade de paradas: </span>
              <span class="font-weight-regular"> {{ cargo?.amountStops }} </span>
            </v-col>
          </v-card-text>
        </div>
        <v-data-table
          id="list02"
          class="w-100"
          v-if="isCollapsed"
          :headers="fileHeaders"
          :items="alocatedStops"
          :items-per-page="alocatedStops.length"
          :loading="isLoadingAlocated"
          loading-text="Carregando..."
          hide-default-footer
        >
          <template v-if="alocatedStops.length > 0" v-slot:[`header.select`]="{}">
            <v-checkbox hide-details v-model="selectAll" class="pa-0 ma-0 ml-6"></v-checkbox>
          </template>
          <template #body="{}">
            <drag-table-alocated
              v-model="alocatedStops"
              :cargo="cargo"
              :selectAll="selectAll"
              @update:allocated="unallocated"
              @update:selectAll="selectAll = $event"
              @loading:allocated="loadingAlocated"
            />
          </template>
        </v-data-table>
      </draggable>
    </section>
    <delete-confirm-dialog
      :isOpen.sync="isDeleteDialogOpen"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      @confirmClick="deleteCargo"
      title="Desfazer Carga"
      :body-text="confirmationText"
    />
  </div>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import DeleteConfirmDialog from '@/components/ConfirmDialog.vue';
import DragTableAlocated from '@/components/ManualBoardingImport/Stepper/Step5/DragTableAlocated.vue';
import maskPrice from '@/utils/maskPrice';
import copyToClipboard from '@/utils/copyToClipboard';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';
import draggable from 'vuedraggable';

export default {
  components: {
    TruncateDataWithTooltip,
    DeleteConfirmDialog,
    DragTableAlocated,
    draggable
  },
  props: {
    cargo: {
      default: () => ({}),
      type: Object
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isDeleteDialogOpen: false,
    isDeleteButtonLoading: false,
    isCollapsed: false,
    selectAll: false,
    selectedNfe: {},
    alocatedStops: [],
    dragOptions: {
      animation: 150,
      group: 'cargosAllocation',
      ghostClass: 'ghost',
      disabled: false,
      handle: 'none'
    }
  }),
  computed: {
    localSelected: {
      get() {
        return this.selected;
      },
      set() {
        this.$emit('update:selected', this.cargo.id);
      }
    },
    fileHeaders() {
      const baseHeaders = [
        { value: 'select', text: '', sortable: false },
        { value: 'stopNumber', text: 'NÚMERO PARADA', sortable: true },
        { value: 'totalPriceNfes', text: 'VALOR MERCADORIAS', sortable: true },
        { value: 'weightDeliveries', text: 'PESO', sortable: true },
        { value: 'nameRecipient', text: 'DESTINATÁRIO', sortable: true },
        { value: 'transhipmentCity', text: 'CIDADE', sortable: true }
      ];
      if (!this.cargo.isDirectDelivery) {
        baseHeaders.splice(2, 0, { value: 'transhipmentPrice', text: 'FRETE TRANSBORDO', sortable: true });
      }
      return baseHeaders;
    },

    confirmationText() {
      if (this.getErrorNfeCount) {
        return 'Você confirma excluir essa parada?';
      } else {
        return 'Confirmar dasalocar as entregas e excluir essa parada?';
      }
    },
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    }
  },
  methods: {
    ...mapActions('ImportManualCargosStore', ['getStopsByCargoId', 'allocateStop']),
    async getStopsByCargo(collapsed = false) {
      this.isLoadingAlocated = true;
      try {
        if (collapsed) {
          this.isCollapsed = !this.isCollapsed;
        }
        const data = await this.getStopsByCargoId(this.cargo.id);
        this.alocatedStops = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingAlocated = false;
      }
    },
    loadingAlocated(loading) {
      this.alocatedStops = [];
      this.isLoadingAlocated = loading;
    },
    openDeleteDialog() {
      this.isDeleteDialogOpen = true;
    },
    deleteCargo() {
      this.$emit('removeCargo', this.cargo.id);
      this.isDeleteDialogOpen = false;
    },
    unallocated(value, msg) {
      this.$emit('update:allocated', value, msg);
      this.getStopsByCargo();
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    },
    async allocateStopToCargo(stops) {
      try {
        let StopsIds;
        if (Array.isArray(stops)) {
          StopsIds = stops.map(({ id }) => id);
        } else {
          StopsIds = [stops.id];
        }
        const params = {
          id: this.cargo.id,
          stopsIds: StopsIds
        };

        const response = await this.allocateStop(params);
        if (response.success) {
          this.unallocated('Entrega(s) alocadas com sucesso!', true);
        } else {
          const draggedItemIndex = this.alocatedStops.findIndex((item) => item === stops);
          this.alocatedStops.splice(draggedItemIndex, 1);
          this.$emit(
            'update:allocated',
            response.errors[0] || 'Entrega(s) com destinatário ou remetente distintos!',
            false
          );
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onAdd(e) {
      this.loadingAlocated(true);
      if (e.item._selected_items.length > 1) {
        const draggedItems = e.item._selected_items;
        await this.allocateStopToCargo(draggedItems);
      } else {
        await this.allocateStopToCargo(e.item._underlying_vm_);
      }
      await this.loadingAlocated(false);
      await this.getStopsByCargo();
      this.$emit('update:selectAll', false);
    }
  }
};
</script>

<style scoped>
* {
  transition: 0ms;
}
.ghost {
  display: none !important;
}
.cargo-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
</style>
